import React, { useEffect } from 'react'
import FormattedMessage from '../../../helpers/FormattedMessage'

import Banner  from '../../../assets/images/Banner.png'
import styles from './ThanksPage.module.scss'


export const ThanksPage = () => {
  useEffect(() => {
    window.localStorage.clear()
  }, [])

  return (
    <>
      <img className={styles.MobileBanner} src={Banner} alt="models" />
      <div className={styles.Wrapper}>
        <div className={styles.TextBlock}>
          <h3 className={styles.Title}><FormattedMessage id="SchoolShop.thanksPage.title"/></h3>
          <p className={styles.Text}><FormattedMessage id="SchoolShop.thanksPage.text"/></p>
          <a href="https://www.abcgruppen.se/kundservice/" target="_blank" rel="noreferrer" className={styles.Link}>
            <FormattedMessage id="SchoolShop.thanksPage.link"/>
          </a>
        </div>

      </div>
    </>
  )
}
